import Vue from "vue";

const state = {
  invite: {}
};

const getters = {};

const actions = {
  ACCEPT_INVITE: async function(context, payload) {
    await Vue.prototype.$axios.post("invites/" + payload.id + "/accept", {
      password: payload.password
    });
  },
  GET_INVITE: async function({ commit }, payload) {
    Vue.prototype.$axios.get("invites/" + payload).then(res => {
      commit("SET_INVITE", res.data.invite);
    });
  }
};

const mutations = {
  SET_INVITE: function(state, payload) {
    state.invite = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
